import { estilosPreferenciasRecolhiveis, painelPreferenciasRecolhiveis } from "./preferencias";

// Ajuda acompanha o padrão compacto e a paleta das Preferências.
export const painelMenuAjuda = {
  ...painelPreferenciasRecolhiveis,
  // A posição acompanha o botão de Ajuda, no canto inferior esquerdo.
  right: "auto",
  mb: 0,
};

export const estilosMenuAjuda = {
  cabecalho: estilosPreferenciasRecolhiveis.cabecalho,
  iconeCabecalho: estilosPreferenciasRecolhiveis.iconeCabecalho,
  tituloCabecalho: estilosPreferenciasRecolhiveis.tituloCabecalho,
  descricaoCabecalho: estilosPreferenciasRecolhiveis.descricaoCabecalho,
  fechar: estilosPreferenciasRecolhiveis.fechar,
  linha: { ...estilosPreferenciasRecolhiveis.linha, width: "100%", textAlign: "left" },
  iconeLinha: estilosPreferenciasRecolhiveis.iconeLinha,
  textoLinha: estilosPreferenciasRecolhiveis.textoLinha,
  tituloLinha: estilosPreferenciasRecolhiveis.tituloLinha,
  descricaoLinha: estilosPreferenciasRecolhiveis.descricaoLinha,
  seta: estilosPreferenciasRecolhiveis.seta,
  divisor: estilosPreferenciasRecolhiveis.divisor,
};
